import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  getCurrentTask,
  getQuotes,
  getSelectedQuoteId,
} from '../../../../../selectors/admin/work-orders/details/details';
import {
  closeQuoteDetailsModal,
  counterQuote,
  updateQuoteRequest,
  deleteQuote,
} from '../../../../../actions/admin/work-orders/details/details';
import { getCurrentWorkOrder } from '../../../../../selectors/admin/work-orders/work-orders';
import QuoteDetailsModal from '../../../quotes/QuoteDetailsModal';

class QuoteDetailsModalContainer extends Component {
  handleClose = () => {
    this.props.dispatch(closeQuoteDetailsModal());
  };

  handleNegotiate = (counter, callback) => {
    this.props
      .dispatch(counterQuote(this.props.selectedQuoteId, counter))
      .then((response) => callback(response));
  };

  handleEdit = (estimate, value, contractorId) => {
    this.props.dispatch(
      updateQuoteRequest(
        this.props.selectedQuoteId,
        estimate,
        value,
        contractorId
      )
    );
  };

  handleDelete = () => {
    this.props.dispatch(deleteQuote(this.props.selectedQuoteId));
  };

  render() {
    const quote = this.props.quotes.find(
      (element) => element.id === this.props.selectedQuoteId
    );

    return (
      quote !== undefined && (
        <QuoteDetailsModal
          quote={quote}
          show={this.props.selectedQuoteId !== null}
          taskImages={this.props.currentTask.images}
          workOrder={this.props.currentWorkOrder}
          onNegotiate={this.handleNegotiate}
          onEdit={this.handleEdit}
          onClose={this.handleClose}
          onDelete={this.handleDelete}
        />
      )
    );
  }
}

export default connect((state) => {
  return {
    currentTask: getCurrentTask(state),
    currentWorkOrder: getCurrentWorkOrder(state),
    quotes: getQuotes(state),
    selectedQuoteId: getSelectedQuoteId(state),
  };
})(QuoteDetailsModalContainer);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/quotes/QuoteDetailsModalContainer.js